import {createSlice} from '@reduxjs/toolkit';
import {connect} from 'react-redux';

import {RootState} from 'App/store/rootReducer';

type viewModes2DSlice = {
  edition2DMode: boolean;
  shouldDisplaySpinner: boolean;
  isLandRegistryEditorMode: boolean;
  isMap2DLoaded: boolean;
};

const initialState: viewModes2DSlice = {
  edition2DMode: false,
  shouldDisplaySpinner: false,
  isLandRegistryEditorMode: false,
  isMap2DLoaded: false,
};

const viewModes2DSlice = createSlice({
  name: 'viewModes2D',
  initialState,
  reducers: {
    enableEdition2DMode: state => {
      state.edition2DMode = true;
    },
    disableEdition2DMode: state => {
      state.edition2DMode = false;
    },
    displaySpinner: state => {
      state.shouldDisplaySpinner = true;
    },
    hideSpinner: state => {
      state.shouldDisplaySpinner = false;
    },
    enableLandRegistryEditorMode: state => {
      state.isLandRegistryEditorMode = true;
    },
    disableLandRegistryEditorMode: state => {
      state.isLandRegistryEditorMode = false;
    },
    setMap2DLoaded: state => {
      state.isMap2DLoaded = true;
    },
  },
});

const map2DViewModesToProps = (state: RootState): viewModes2DSlice =>
  state.map2DEntities.viewModes2D;

export const connectTo2DViewModes = connect(map2DViewModesToProps, null, null, {
  forwardRef: true,
});

export const selectEdition2DMode = (state: RootState): boolean =>
  state.map2DEntities.viewModes2D.edition2DMode;
export const selectIsLandRegistryEditorMode = (state: RootState): boolean =>
  state.map2DEntities.viewModes2D.isLandRegistryEditorMode;
export const selectIsMap2DLoaded = (state: RootState): boolean =>
  state.map2DEntities.viewModes2D.isMap2DLoaded;

export const {
  enableEdition2DMode,
  disableEdition2DMode,
  displaySpinner,
  hideSpinner,
  enableLandRegistryEditorMode,
  disableLandRegistryEditorMode,
  setMap2DLoaded,
} = viewModes2DSlice.actions;

export default viewModes2DSlice.reducer;
